export const enumToSelectOptions = (enumObj, displayMap) => {
    return Object.values(enumObj).map((val) => ({
        displayText: displayMap.get(val),
        label: displayMap.get(val),
        value: val
    }));
};
